import React from "react";

function TickPoints({ dataArray = [] }) {
  return (
    <>
      {dataArray.map((item, index) => {
        return (
          <div key={index} className="flex flex-row items-center mt-5">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="flex-2 h-5 w-5 mr-5  text-green-500"
              viewBox="0 0 20 20"
              fill="currentColor"
            >
              <path
                fillRule="evenodd"
                d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                clipRule="evenodd"
              />
            </svg>
            <p className="flex-8">{item} </p>
          </div>
        );
      })}
    </>
  );
}

export default TickPoints;
